/**
 * Maximum number of debug records to keep in memory.
 *
 * These are records, not calls: one investigated interaction can be several.
 * A warm transfer is two (both legs), and a four-party conference is five
 * (four participant legs plus the room). At the old value of 10, a single
 * conference could evict almost everything around it — including the calls it
 * was being compared against.
 */
export const MAX_RECENT_CALLS = 50;
